function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2047 16.1366L5.85608 7.89673V12.4585L17.915 18.1867L5.8457 24.1311L5.85608 28.6264L23.2047 36.8663V32.3045L11.2952 26.647L23.2047 20.7753V16.1366Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3604 37.1138L5.70044 28.7242L5.68799 24.0335L17.556 18.191L5.70044 12.5584V7.64941L23.3604 16.039V20.8752L11.6542 26.645L23.3604 32.2069V37.1138ZM6.01794 28.5267L23.0532 36.6189V32.4044L10.9362 26.6492L23.0491 20.6798V16.2365L6.01794 8.14426V12.3609L18.2803 18.1827L6.00134 24.229L6.01794 28.5267Z",
  fill: "#AA6039"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7887 14.2759L10.4401 6.02979L5.85596 7.90107L23.2046 16.141L27.7887 14.2759Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1987 16.3072L23.1365 16.2781L5.46826 7.88439L10.4487 5.86133L10.511 5.89044L28.1792 14.2842L23.1987 16.3072ZM6.24438 7.90103L23.2091 15.96L27.3927 14.2634L10.4363 6.2044L6.24438 7.90103Z",
  fill: "#AA6039"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2051 20.7755L27.7892 18.9146V14.2759L23.2051 16.1368V20.7755Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0474 21V16.0328L27.9448 14.043V19.0185L23.0474 21ZM23.3607 16.2344V20.5446L27.6335 18.8085V14.5066L23.3607 16.2344Z",
  fill: "#AA6039"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7892 35.0055V21.0728L23.2051 23.1831V32.3046V36.8664L27.7892 35.0055Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0474 37.0991V23.0791L27.9448 20.8252V35.1072L23.0474 37.0991ZM23.3607 23.287V36.6355L27.6335 34.8993V21.3159L23.3607 23.287Z",
  fill: "#AA6039"
});

function SvgZilSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilSymbol);
export default __webpack_public_path__ + "static/media/zil-symbol.e424bba5.svg";
export { ForwardRef as ReactComponent };